import React, { createContext, useContext, useMemo, useState } from 'react'

const Ctx = createContext<{ isLoading: boolean; setIsLoading: (v: boolean) => void } | undefined>(undefined)

export const Provider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false)
  const value = useMemo(() => ({ isLoading, setIsLoading }), [isLoading])
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export const useLoadingContext = () => {
  const v = useContext(Ctx)
  if (!v) throw new Error('Loading context not provided')
  return v
}


